var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55934",
    "data-name": "Group 55934",
    transform: "translate(-0.077 0.189)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_622",
    "data-name": "Ellipse 622",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0.077 -0.189)",
    fill: "#1e1e1e",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("g", {
    id: "tick_4_",
    "data-name": "tick (4)",
    transform: "translate(8.775 11.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55687",
    "data-name": "Group 55687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87442",
    "data-name": "Path 87442",
    d: "M22.358,68.33a1.135,1.135,0,0,0-1.6,0L7.161,81.922,1.936,76.7a1.135,1.135,0,0,0-1.6,1.6l6.027,6.027a1.135,1.135,0,0,0,1.6,0L22.358,69.934A1.135,1.135,0,0,0,22.358,68.33Z",
    transform: "translate(0 -67.997)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.96a0f928ee924bd3cdaa2038be879ab3.svg";
export { ForwardRef as ReactComponent };